import { Controller } from 'stimulus';
import axios from "axios";
import i18next from "i18next";
import utils from '../../packs/utils';

const specimenTypeDescSelector = "[data-portal--submission-setup-target='specimenTypeDescription']"
const autoCompleteInputSelector = "[data-portal--submission-setup-target='autoCompleteInput']"

const autoCompleteSetupSpecimenTypeIDs = "[data-input-name='setup_specimen_type_ids[]']"
const autoCompleteSetupTransporMediumIDs = "[data-input-name='setup_transport_medium_ids[]']"

const autoCompleteHiddenSelector = "[data-portal--submission-setup-target='autoCompleteHidden']"

export default class extends Controller {

  static targets = [
    "template",
    "target",
    "specimenTypeDescription",
    "record",
    "specimenIndex",
  ];

  static values = {
    id: { type: Number, default: 0 },
    specimenTypes: { type: Array, default: [] },
    wrapperSelector: { type: String, default: ".specimen-types-wrapper" },
    setupSpecimenTypesData: Array,
    setupSpecimenCount: { type: Number, default: 0 },
    setupTransportMediumData: Array,
    setupCollectionDateData: Array,
  };

  connect() {
    this.generateProcess()
    this.boundLoadSpecimenData = this.loadSpecimenDescTypes.bind(this)
    document.addEventListener("autocomplete:triggerAutocompleteChangeEvent", this.boundLoadSpecimenData)
  }

  generateProcess() {
    const isGenerateExisting = this.setupSpecimenTypesDataValue.length || this.setupTransportMediumDataValue.length || this.setupCollectionDateDataValue.length
    if (isGenerateExisting) {
      this.generateSpecimens()
    } else {
      if (this.hasTargetTarget && this.hasTemplateTarget) {
        this.add(new CustomEvent("add"))
      }
    }
  }

  disconnect() {
    document.removeEventListener("autocomplete:triggerAutocompleteChangeEvent", this.boundLoadSpecimenData)
  }

  add(n) {
    this.idValue++
    n.preventDefault();
    const r = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g, this.idValue
    );
    this.targetTarget.insertAdjacentHTML("beforebegin", r);
    this.refreshIndexValue()
  }

  loadSpecimenDescTypes(e) {
    const event = e.detail.event

    // Only loading for specimen type ids
    if (event && event.target.dataset.inputName.indexOf("setup_specimen_type_ids") == -1) return

    let id = event.detail.value
    let url = "/specimen_type_descriptions/ajax_search?specimen_type_id=" + parseInt(id)
    axios({
      url: url,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }).then(res => {
      this.updateSpecimenTypeDescDropdown(res.data, e);
    })
  }

  updateSpecimenTypeDescDropdown(data, e) {
    let target = document.querySelector(`${specimenTypeDescSelector}[data-id="${e.target.dataset.id}"]`)
    if (target) target.innerHTML = "";

    // Add a empty option
    const option = document.createElement("option");
    option.value = "";
    option.innerHTML = i18next.t("Select Type Description")
    if (target) target.appendChild(option);
    data.forEach((item) => {
      const option = document.createElement("option");
      option.value = item.id;
      option.innerHTML = item.value
      target.appendChild(option);
    });
  }

  processSpecimenTypes(e) {
    const specimenCount = parseInt(e.target.value)
    const recordsCount = this.recordTargets.length
    if (recordsCount == 1 && specimenCount == 1) return

    let diffCount = specimenCount - recordsCount
    if (diffCount > 0) {
      while (diffCount > 0) {
        this.add(e)
        diffCount--
      }
    } else {
      diffCount = Math.abs(diffCount)
      while (diffCount > 0) {
        const lastRecord = this.recordTargets[this.recordTargets.length - 1]
        lastRecord.remove()
        diffCount--
      }
      this.refreshIndexValue()
    }
  }

  refreshIndexValue() {
    for (let i = 0; i < this.specimenIndexTargets.length; i++) {
      const target = this.specimenIndexTargets[i];
      target.innerHTML = "Specimen " + (i + 1)
    }
  }

  async generateSpecimens() {
    for (let i = 0; i < this.setupSpecimenCountValue; i++) {
      await (this.startToAdd()).then(res => {
        if (this.setupSpecimenTypesDataValue) this.fillSpecimenTypesAndDescription(i)
        if (this.setupTransportMediumDataValue) this.fillTransportMediumData(i)
        if (this.setupCollectionDateDataValue) this.fillCollectionDateData(i)
      })
    }
  }

  fillTransportMediumData(i) {
    const transportMedium = this.setupTransportMediumDataValue[i]
    if (!transportMedium) return
    if (utils("isObjectEmpty", transportMedium, "")) return

    const inputTarget = document.querySelector(`${autoCompleteSetupTransporMediumIDs}${autoCompleteInputSelector}[data-id="${i + 1}"]`)
    const hiddenTarget = document.querySelector(`${autoCompleteSetupTransporMediumIDs}${autoCompleteHiddenSelector}[data-id="${i + 1}"]`)

    if (inputTarget) inputTarget.value = transportMedium.to_label
    if (hiddenTarget) hiddenTarget.value = transportMedium.id
  }

  fillCollectionDateData(i) {
    const setupCollectionDateData = !this.setupCollectionDateDataValue[i]
    if (!setupCollectionDateData) return;
    if (utils("isObjectEmpty", setupCollectionDateData, "")) return

    const originDate = setupCollectionDateData.origin_date
    const formattedDate = setupCollectionDateData.formatted_date
    if (!originDate) return;

    const record = this.recordTargets[i]
    const inputTarget = record.getElementsByClassName("form-control bootstrap-datepicker form-control input")[0]
    const hiddenTarget = record.getElementsByClassName("form-control bootstrap-datepicker flatpickr-input")[0]

    if (inputTarget) inputTarget.value = formattedDate
    if (hiddenTarget) hiddenTarget.value = originDate
  }


  startToAdd = () => {
    return new Promise(resolve => {
      resolve(this.add(new CustomEvent("add"), true));
    })
  }

  fillSpecimenTypesAndDescription(i) {
    const specimenType = this.setupSpecimenTypesDataValue[i]
    if (!specimenType) return
    if (utils("isObjectEmpty", specimenType, "")) return

    const inputTarget = document.querySelector(`${autoCompleteSetupSpecimenTypeIDs}${autoCompleteInputSelector}[data-id="${i + 1}"]`)
    const hiddenTarget = document.querySelector(`${autoCompleteSetupSpecimenTypeIDs}${autoCompleteHiddenSelector}[data-id="${i + 1}"]`)
    if (inputTarget) inputTarget.value = specimenType.long_name
    if (hiddenTarget) hiddenTarget.value = specimenType.id
    const specimenTypeDescTarget = this.specimenTypeDescriptionTargets[i]

    this.generateOptionForSpecimenTypeDesc(specimenType.all_type_descriptions, specimenTypeDescTarget)

    if (specimenType.selected_type_description) {
      Array.from(specimenTypeDescTarget.options).forEach(option => {
        if (option.value && specimenType.selected_type_description) {
          if (parseInt(option.value) === parseInt(specimenType.selected_type_description.id)) option.setAttribute('selected', true);
        }
      })
    }
}

  generateOptionForSpecimenTypeDesc(data, target) {
    if (target && target.options.length === 0) {
      // Add a empty option
      const option = document.createElement("option");
      option.value = "";
      option.innerHTML = i18next.t("Select Type Description")
      target.appendChild(option);
    }
    data.forEach((item) => {
      const option = document.createElement("option");
      option.value = item.id;
      option.innerHTML = item.value ? item.value : item.description
      target.appendChild(option);
    });
  }



}
